import React, { useState } from "react";
import { X } from "lucide-react";
import AutoVideo from "../AutoVideo";

const SPEED = { slow: 7, normal: 4.5, fast: 2.5 };
const isVid = (it) => it.kind === "video" || /\.(mp4|webm|mov)(\?|#|$)/i.test(it.image || "");

// Tira horizontal continua (marquesina) de fotos verticales, en bucle sin cortes.
const MosaicHorizontal = ({ block, SectionHeading }) => {
  const items = (block.items || []).filter((it) => it.image).slice(0, 10);
  const [zoom, setZoom] = useState(null);
  const title = block.title && <SectionHeading titleSize={block.titleSize}>{block.title}</SectionHeading>;

  if (!items.length) {
    return (
      <div className="w-full">
        {title}
        <p className="mt-4 text-center text-xs text-white/40">Agrega fotos para ver el mosaico horizontal.</p>
      </div>
    );
  }

  // Repetimos hasta tener suficientes tarjetas para que nunca quede un hueco.
  let base = items;
  while (base.length < 6) base = [...base, ...items];
  const loop = [...base, ...base];
  const duration = base.length * (SPEED[block.speed] || SPEED.normal);

  return (
    <div className="w-full" data-testid="mosaic-horizontal">
      {title}
      <div className="mh-viewport relative mt-4 overflow-hidden">
        <div className="mh-track flex w-max gap-2.5" style={{ animationDuration: `${duration}s` }}>
          {loop.map((it, i) => (
            <button
              type="button"
              key={`${it.id}-${i}`}
              onClick={() => setZoom(it)}
              className="relative aspect-[9/16] w-[46vw] max-w-[240px] shrink-0 overflow-hidden rounded-2xl border border-white/10 bg-black/30 shadow-[0_12px_30px_rgba(0,0,0,.45)]"
            >
              {isVid(it) ? (
                <AutoVideo src={it.image} className="h-full w-full object-cover" />
              ) : (
                <img
                  src={it.image}
                  alt=""
                  loading="eager"
                  decoding="async"
                  draggable={false}
                  className="h-full w-full object-cover"
                />
              )}
            </button>
          ))}
        </div>
      </div>
      {zoom && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4"
          onClick={() => setZoom(null)}
          data-testid="mosaic-h-zoom"
        >
          <button className="absolute right-4 top-4 rounded-full bg-white/15 p-2 text-white">
            <X className="h-5 w-5" />
          </button>
          {isVid(zoom) ? (
            <video
              src={zoom.image}
              autoPlay
              loop
              playsInline
              controls
              className="max-h-full max-w-full rounded-xl"
              onClick={(e) => e.stopPropagation()}
            />
          ) : (
            <img src={zoom.image} alt="" className="max-h-full max-w-full rounded-xl object-contain" />
          )}
        </div>
      )}
    </div>
  );
};

export default MosaicHorizontal;
